import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";
import { fadeUpInView, fadeUpInViewStaggered } from "./animationVariants";

export default function ProgramProtocol({ program }) {
  return (
    <section className="max-w-6xl mx-auto px-4 md:px-8 mt-20 md:mt-28">
      <motion.div {...fadeUpInView}>
        <div className="eyebrow mb-3">What&rsquo;s included</div>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
          The <em className="not-italic text-primary">protocol</em>.
        </h2>
      </motion.div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
        {program.includes.map((item, i) => (
          <motion.div
            key={item}
            {...fadeUpInViewStaggered(i * 0.06)}
            data-testid={`program-include-${i}`}
            className="premium-card flex items-start gap-4 p-6 bg-card border-2 border-border rounded-2xl hover:border-primary/45 transition-colors"
          >
            <CheckCircle
              size={28}
              weight="duotone"
              className="text-primary flex-shrink-0 mt-0.5"
            />
            <p className="text-lg text-foreground/85 leading-relaxed">{item}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
